import { defineMessages } from '@approvalmax/utils';
export const messages = defineMessages('app.WorkflowIdPage.containers.card.VersionConflictPopup', {
    title: 'Newer workflow version published',
    description:
        "Either refresh the page and start editing the latest workflow version or publish an outdated workflow version with your changes and overwrite others' edits.",
    buttonOverwrite: 'OVERWRITE',
    buttonCancel: 'CONTINUE EDITING',
});
